import { clsx } from 'clsx'
import styles from './LeagueTabs.module.css'

export type LeagueTab = {
  id: string
  label: string
}

type LeagueTabsProps = {
  tabs: LeagueTab[]
  activeTab: string
  onTabChange: (tabId: string) => void
}

export function LeagueTabs({ tabs, activeTab, onTabChange }: LeagueTabsProps) {
  return (
    <nav className={styles.nav} aria-label="Seções da liga">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={clsx(styles.tab, activeTab === tab.id && styles.isActive)}
          onClick={() => onTabChange(tab.id)}
          aria-current={activeTab === tab.id ? 'page' : undefined}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  )
}
